
import Icon from '@material-ui/icons/LibraryAddCheck';
import List from './CheckList'
import Create from './CheckListCreate'
import Edit from './CheckListEdit'
import Show from './CheckListView'


export default {
    list: List,
    icon: Icon,
    create: Create,
    edit: Edit,
    show: Show
};

